export default "__VITE_ASSET__Cu68MsJB__"